import { render } from "./MDialog.vue?vue&type=template&id=608be0ba&scoped=true"
import script from "./MDialog.vue?vue&type=script&lang=js"
export * from "./MDialog.vue?vue&type=script&lang=js"

import "./MDialog.vue?vue&type=style&index=0&id=608be0ba&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608be0ba"]])

export default __exports__